<template>
  <section class="flex h-screen">
    <div class="m-auto w-full p-6">
      <h1 class="text-xl font-bold text-gray-900 mb-5">
        Faça login na sua conta
      </h1>
      <form class="space-y-4 md:space-y-6" @submit.prevent="form.post(route('mobile.authenticated'))">
        <div>
          <label for="email" class="block text-sm font-medium text-gray-900">Seu email</label>
          <input type="email"
                 v-model="form.email"
                 name="email" id="email" class="border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5" placeholder="name@company.com" required="">
        </div>
        <div>
          <label for="password" class="block text-sm font-medium text-gray-900">Sua Senha</label>
          <input type="password"
                 v-model="form.password"
                 name="password" id="password" placeholder="••••••••" class="border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5" required="">
        </div>
        <button type="submit" class="w-full text-white bg-blue-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Entrar</button>
      </form>
    </div>
  </section>
</template>

<script>
import {useForm} from "@inertiajs/inertia-vue3";

export default {
  name: "Login.vue",
  setup() {
    const form = useForm({
      email: null,
      password: null,
    })

    return {form}
  },
}
</script>

<style scoped>

</style>
